import { PendingImportsCard } from '@/components/modules/dashboard/pending-imports/card';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover';
import { Text } from '@/components/text';
import { LoadingSpinner } from '@/components/ui/loading/spinner';
import { TrackingRequestModel } from '@/lib/models/tracking-request/types';
import { tv } from '@/utils/styles';

export interface TrackingRequestPendingProps {
  count: number;
  trackingRequests?: TrackingRequestModel[];
  onTogglePopover?: (isOpen: boolean) => void;
}

const TrackingRequestPending = ({ count, trackingRequests, onTogglePopover }: TrackingRequestPendingProps) => {
  const { trigger, countBadge, loadingWrapper } = styles();
  return (
    <Popover onOpenChange={onTogglePopover}>
      <PopoverTrigger asChild>
        <div className={trigger()}>
          <Text>Pending imports</Text>
          <Text className={countBadge()}>{count}</Text>
        </div>
      </PopoverTrigger>
      <PopoverContent className="max-w-md p-0" align="end">
        {trackingRequests?.length ? (
          <PendingImportsCard trackingRequests={trackingRequests} />
        ) : (
          <div className={loadingWrapper()}>
            <LoadingSpinner isVisible />
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

const styles = tv({
  slots: {
    trigger:
      'inline-flex cursor-pointer items-center gap-2 rounded-full border border-solid border-yellowDark bg-yellowDark py-1 pl-3 pr-1.5 text-xs font-medium hover:bg-yellowMid [&_p]:m-0',
    countBadge:
      'grid h-4 min-w-4 place-items-center rounded-full bg-white px-1 text-xxs font-medium leading-none text-text-primary',
    loadingWrapper: 'min-h-4xl min-w-4xl rounded bg-white',
  },
});

export { TrackingRequestPending };
